export function belowMaxPrice(calc, maxPrice) {
    return calc.prc_no_vat <= maxPrice;
}
export function aboveMinKm(calc, minKm) {
    return calc.km_y >= minKm;
}
export function belowMaxDuration(calc, maxDuration) {
    return calc.mnts <= maxDuration;
}
export function aboveMinPower(car, minPower) {
    return car.pwr_kw >= minPower;
}
export function filterInStock(car, stockValue) {
    if (car.stock !== undefined) {
        return !stockValue ? true : car.stock;
    }
    return false;
}
export function filterManufac(car, manufacValue) {
    if (manufacValue.length > 0) {
        return manufacValue.includes(car.manufac);
    }
    return true;
}
export function filterModel(car, mdlValue) {
    if (mdlValue.length > 0) {
        return mdlValue.includes(car.mdl);
    }
    return true;
}
export function filterTransition(car, transValue) {
    if (transValue.length > 0) {
        return transValue.includes(car.trans);
    }
    return true;
}
export function filterEqpLev(car, eqpValue) {
    if (eqpValue.length > 0 && car.eqp_lev) {
        return eqpValue.includes(car.eqp_lev);
    }
    return true;
}
export function filterBody(car, bodyValue) {
    if (bodyValue.length > 0) {
        return bodyValue.includes(car.body);
    }
    return true;
}
export function filterDrive(car, driveValue) {
    if (driveValue.length > 0) {
        return driveValue.includes(car.drive);
    }
    return true;
}
export function filterFuel(car, fuelValue) {
    if (fuelValue.length > 0) {
        return fuelValue.includes(car.fuel_s);
    }
    return true;
}
export function filterColor(car, colorValue) {
    if (colorValue.length > 0 && car.col) {
        return colorValue.includes(car.col);
    }
    return true;
}
